import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext.jsx';
import App from './App.jsx';
import { registerSW } from './offline/swRegister.js';
import { requestPersistentStorage } from './offline/storagePersist.js';
import { checkClientVersion } from './offline/versionCheck.js';
import './main.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);

// Register Service Worker
registerSW();

// Request persistent storage
requestPersistentStorage();

// Version check
checkClientVersion();

// Auto night mode (20h-6h)
function updateNightMode() {
  const hour = new Date().getHours();
  const isNight = hour >= 20 || hour < 6;
  document.documentElement.classList.toggle('night-mode', isNight);
}
updateNightMode();
setInterval(updateNightMode, 60000);
